<div class="row justify-content-center mt-5">
  <div class="col-md-6 col-xl-4">
    <div class="card mb-4">
      <div class="card-header py-3">
        @if (accountActivation) {
          <span class="font-20">Welcome to Firm360!!</span>
        }
        @if (!accountActivation) {
          <span class="font-20">Reset Password</span>
        }
      </div>
      <div class="card-body">
        @if (keyMissing) {
          <div class="alert alert-danger">
            The password reset key is missing.
          </div>
        }
        @if (invalidKey) {
          <div class="alert alert-danger">
            {{ invalidKeyMessage }}
          </div>
        }

        @if (!keyMissing && !invalidKey && !accountActivation) {
          <p class="text-muted">Choose a new password.</p>
        }

        @if (error) {
          <div class="alert alert-danger">
            <span>{{ error }}</span>
          </div>
        }

        @if (doNotMatch) {
          <div class="alert alert-danger">
            The password and its confirmation do not match!
          </div>
        }

        @if (accountActivation) {
          <p class="text-muted">
            Let's get started. First, choose a secure password and enter it
            below.
          </p>
        }

        @if (!keyMissing && !invalidKey) {
          <div>
            <form
              (ngSubmit)="finishReset()"
              [formGroup]="passwordForm"
              name="form"
              role="form"
            >
              <div class="mb-3">
                <label class="form-control-label" for="password">
                  @if (!accountActivation) {
                    <span>New Password</span>
                  }
                  @if (accountActivation) {
                    <span>Password</span>
                  }
                </label>
                <input
                  #passwordField
                  class="form-control"
                  formControlName="newPassword"
                  id="password"
                  name="password"
                  [placeholder]="
                    accountActivation ? 'Password' : 'New Password'
                  "
                  type="password"
                  autocomplete="off"
                />
                @if (
                  passwordForm.get("newPassword").invalid &&
                  (passwordForm.get("newPassword").dirty ||
                    passwordForm.get("newPassword").touched)
                ) {
                  <div>
                    @if (passwordForm.get("newPassword").errors.required) {
                      <small class="form-text text-danger">
                        Your password is required.
                      </small>
                    }
                    @if (passwordForm.get("newPassword").errors.minlength) {
                      <small class="form-text text-danger">
                        Your password is required to be at least 8 characters.
                      </small>
                    }
                    @if (passwordForm.get("newPassword").errors.maxlength) {
                      <small class="form-text text-danger">
                        Your password cannot be longer than 100 characters.
                      </small>
                    }
                    @if (passwordForm.get("newPassword").errors.pattern) {
                      <small class="form-text text-danger">
                        Password Requirements:
                        <ul>
                          <li>Uppercase Letters</li>
                          <li>Lowercase Letters</li>
                          <li>Numbers</li>
                          <li>
                            Special Characters: !&#64;#$%^&*()-_=+;:,.<>/?
                          </li>
                        </ul>
                      </small>
                    }
                  </div>
                }
                <div class="mt-3">
                  <jhi-password-strength-bar
                    [passwordToCheck]="passwordForm.get('newPassword').value"
                  ></jhi-password-strength-bar>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-control-label" for="confirmPassword">
                  @if (!accountActivation) {
                    <span>Confirm New Password</span>
                  }
                  @if (accountActivation) {
                    <span>Confirm Password</span>
                  }
                  <span></span>
                </label>
                <input
                  class="form-control"
                  formControlName="confirmPassword"
                  id="confirmPassword"
                  name="confirmPassword"
                  [placeholder]="
                    accountActivation
                      ? 'Confirm Password'
                      : 'Confirm New Password'
                  "
                  type="password"
                  autocomplete="off"
                />
                @if (
                  passwordForm.get("confirmPassword").invalid &&
                  (passwordForm.get("confirmPassword").dirty ||
                    passwordForm.get("confirmPassword").touched)
                ) {
                  <div>
                    @if (passwordForm.get("confirmPassword").errors.required) {
                      <small class="form-text text-danger">
                        Your password confirmation is required.
                      </small>
                    }
                    @if (passwordForm.get("confirmPassword").errors.minlength) {
                      <small class="form-text text-danger">
                        Your password confirmation is required to be at least 8
                        characters.
                      </small>
                    }
                    @if (passwordForm.get("confirmPassword").errors.maxlength) {
                      <small class="form-text text-danger">
                        Your password confirmation cannot be longer than 100
                        characters.
                      </small>
                    }
                  </div>
                }
              </div>
              <button
                [disabled]="passwordForm.invalid"
                class="btn btn-primary"
                type="submit"
              >
                @if (!accountActivation) {
                  <span>Reset Password</span>
                }
                @if (accountActivation) {
                  <span>Submit</span>
                }
              </button>
            </form>
          </div>
        }
      </div>
    </div>
  </div>
</div>
